<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{ aLang.c_create }} khu giải trí</span>
        <span v-if="mData.viewMode == 'update'">{{ aLang.c_update }} khu giải trí</span>
        <span v-if="mData.viewMode == 'detail'">{{ aLang.c_detail }} khu giải trí</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm" label-width="100%" label-position="top">
          <b-row>
            <b-col md="4">
              <el-form-item label="Tên" prop="thong_tin_chung.ten">
                <el-input v-model="mData.dataForm.thong_tin_chung.ten" :disabled="mData.viewMode == 'detail'"
                  clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Địa chỉ" prop="thong_tin_chung.dia_chi">
                <el-input v-model="mData.dataForm.thong_tin_chung.dia_chi" :disabled="mData.viewMode == 'detail'"
                  clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Email" prop="thong_tin_chung.email">
                <el-input v-model="mData.dataForm.thong_tin_chung.email" :disabled="mData.viewMode == 'detail'"
                  clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="5">
              <el-form-item label="Điện thoại" prop="thong_tin_chung.dien_thoai">
                <el-input v-model="mData.dataForm.thong_tin_chung.dien_thoai" :disabled="mData.viewMode == 'detail'"
                  clearable></el-input>
              </el-form-item>
            </b-col>
            <b-col md="5">
              <el-form-item label="Tỉnh thành" prop="tinh_thanh">
                <el-select v-model="mData.dataForm.tinh_thanh" :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'" clearable filterable>
                  <el-option v-for="item in mData.dataDefault.listProvince" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="2" v-if="mData.ifHavePermission">
              <el-form-item label="Trạng thái" prop="duyet.duoc_duyet">
                <el-select v-model="mData.dataForm.duyet.duoc_duyet" :placeholder="aLang.c_select" disabled clearable
                  filterable>
                  <el-option v-for="item in mData.dataDefault.listAccept" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="4" style="margin-bottom: 10px;">
              <el-form-item class="mb-3" label="Ảnh đại diện" prop="mediaId">
                <el-upload action :auto-upload="false" list-type="picture-card"
                  :limit="mData.fileUploadOption.AnhDaiDien.limit" :accept="mData.fileUploadOption.AnhDaiDien.accept"
                  :on-change="fn_uploadChangeAnhDaiDien" :on-preview="fn_uploadPreviewAnhDaiDien"
                  :on-remove="fn_uploadRemoveAnhDaiDien" :on-exceed="fn_uploadExceedAnhDaiDien"
                  :file-list="mData.fileUploadOption.AnhDaiDien.fileList" :disabled="mData.viewMode == 'detail'"
                  :class="[mData.fileUploadOption.AnhDaiDien.fileList.length > 0 ? 'hidden-icon-upload' : '']">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :close-on-click-modal="true" :visible.sync="mData.fileUploadOption.AnhDaiDien.dialogVisible"
                  width="60%" top="51px" title="Chi tiết">
                  <img width="100%" :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl" alt />
                </el-dialog>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4" lg="3" cols="12" v-for="item in mData.dataForm.thong_tin_chung.link_dich_vu" :key="item.id">
              <el-form-item :label="'Link ' + (item.ten ? item.ten : '')" prop="">
                <el-input v-model="item.link" :disabled="mData.viewMode == 'accept'" @input="forceUpdateUI"
                  clearable></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8">
              <b-row>
                <b-col>
                  <el-form-item class="mb-0" label="Địa chỉ trên bản đồ" prop="mediaId">
                    <mapbox-component :viewMode="mData.viewMode" @update="fn_getDataFromMapboxComponent"
                      :cordinatesValue="mData.mapDataObject.value" :prop-disabled="mData.viewMode == 'detail'"
                      v-if="mData.dataDefault.showMap" id="mapBox"></mapbox-component>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="12">
              <el-form-item label="Giới thiệu" prop="mo_ta">
                <CknoimgComponent v-model="mData.dataForm.mo_ta" :prop-data-editor-disabled="mData.viewMode == 'detail'"
                  @blur="handleBlur('mo_ta')"></CknoimgComponent>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Chi tiết" prop="chi_tiet">
                <CknoimgComponent v-model="mData.dataForm.chi_tiet"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'" @blur="handleBlur('chi_tiet')">
                </CknoimgComponent>
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button type="info" plain @click="fn_submitForm('create')" v-ladda v-if="mData.viewMode == 'create'">{{
              aLang.c_create
            }}</el-button>

            <el-button type="info" plain @click="fn_submitForm('update')" v-ladda v-if="mData.viewMode == 'update'">{{
              aLang.c_update
            }}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{ aLang.c_back }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from '../../../service/LanguageService';
import MethodService from '../../../service/MethodService';
import VuiChoiGiaiTriModel from './VuiChoiGiaiTriModel';
import VuiChoiGiaiTriApi from '../../../moduleApi/VuiChoiGiaiTriApi';
import DDATApi from '@/moduleApi/DDATApi';
import ProvinceApi from '../../../moduleApi/ProvinceApi';
import NenTangDichVuApi from '@/moduleApi/NenTangDichVuApi';
import ExtensionService from "../../../service/ExtensionService";
import CknoimgComponent from "../../../component/CknoimgComponent";
import MapboxComponent from "../../../component/MapboxComponent";
export default {
  components: {
    CknoimgComponent,
    MapboxComponent
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "VuiChoiGiaiTri",
        dataDefault: {
          showMap: false,
          listProvince: [],
          listAccept: [
            {
              value: 0,
              label: 'Đã duyệt'
            },
            {
              value: 1,
              label: 'Chờ duyệt'
            },
            {
              value: 2,
              label: 'Từ chối'
            }
          ]
        },
        dataForm: MethodService.copyObject(VuiChoiGiaiTriModel.dataForm),
        dataFormOther: MethodService.copyObject(VuiChoiGiaiTriModel.dataFormOther),
        fileUploadOption: MethodService.copyObject(
          VuiChoiGiaiTriModel.dataFormOther.fileUploadOption
        ),
        validForm: VuiChoiGiaiTriModel.validForm,
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
        ifHavePermission: false,
        dataPropMapDiaDiem: {
          fn_addLatLng: this.fn_addLatLngDiaDiem,
          lat: "",
          lng: "",
          showMap: false,
          id: "MapDiaDiem",
        },
        mapDataObject: {
          value: [105.850176, 21.0287797],
          geoJson: {
            type: "",
            coordinates: [],
          },
        },
      },
    };
  },
  async mounted() {
    let tinh_thanh = await ProvinceApi.list({
      limit: 1000
    });
    if (tinh_thanh.result) {
      this.mData.dataDefault.listProvince = tinh_thanh.result.map(item => {
        return { value: item.name, label: item.name }
      });
    }
  },
  async created() {
    if (this.mData.currentUser.id) {
      let dataFilter = {
        filters: 'nguoi_tao_id=' + this.mData.currentUser.id
      };
      let resDDAT = await DDATApi.list(dataFilter);
      this.mData.dataFormOther.id = resDDAT.result[0].id;
      await this.fn_getDataById(this.mData.dataFormOther.id);
      if (
        !this.mData.dataForm.id
      ) {
        this.mData.viewMode = "create";
        let nen_tang_dich_vu = await NenTangDichVuApi.list({
          filters: "dich_vu=Giải trí"
        });
        if (nen_tang_dich_vu.result) {
          for (const element of nen_tang_dich_vu.result) {
            element.link = "";
          }
        }
        this.mData.dataForm.thong_tin_chung.link_dich_vu = nen_tang_dich_vu.result;
      } else {
        this.mData.ifHavePermission = true;
        this.mData.viewMode = "update";
      }
    }
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          if (type === "create") {
            data.thong_tin_chung.kinh_do = this.mData.mapDataObject.value[0];
            data.thong_tin_chung.vi_do = this.mData.mapDataObject.value[1];
            await VuiChoiGiaiTriApi.create(data);
            this.fn_resetForm();
            this.$router.push({ name: "Admin-ThongTinDDAT-detail" });
          }
          if (type === "update") {
            data.id = this.mData.dataFormOther.id;
            data.duyet.duoc_duyet = 0;
            data.thong_tin_chung.kinh_do = this.mData.mapDataObject.value[0];
            data.thong_tin_chung.vi_do = this.mData.mapDataObject.value[1];
            await VuiChoiGiaiTriApi.update(data);
            this.$router.push({ name: "Admin-ThongTinDDAT-detail" });
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(
        VuiChoiGiaiTriModel.dataForm
      );

      this.$refs["myForm"].resetFields();
    },

    async fn_getDataById(id) {
      let vui_choi_giai_tri = await VuiChoiGiaiTriApi.findById(id);
      let resForm = {};


      if (vui_choi_giai_tri.result) {
        this.mData.dataForm = vui_choi_giai_tri.result;
        if (vui_choi_giai_tri.result.mediaId) {
          let data = {
            id: vui_choi_giai_tri.result.mediaId,
            name: vui_choi_giai_tri.result.mediaId,
            url: ExtensionService.urlImg + vui_choi_giai_tri.result.mediaId
          };
          this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
        }
        if (
          vui_choi_giai_tri.result.thong_tin_chung.kinh_do &&
          vui_choi_giai_tri.result.thong_tin_chung.vi_do
        ) {
          this.mData.dataPropMapDiaDiem.lat = vui_choi_giai_tri.result.thong_tin_chung.vi_do;
          this.mData.dataPropMapDiaDiem.lng = vui_choi_giai_tri.result.thong_tin_chung.kinh_do;
          this.mData.dataPropMapDiaDiem.showMap = true;

          let coordinate = [
            vui_choi_giai_tri.result.thong_tin_chung.kinh_do,
            vui_choi_giai_tri.result.thong_tin_chung.vi_do,
          ];
          this.mData.mapDataObject.value = coordinate;
          this.mData.mapDataObject.geoJson.type = "Point";
          this.mData.mapDataObject.geoJson.coordinates = coordinate;
          this.mData.dataDefault.showMap = true;
        }
        else if (
          vui_choi_giai_tri.result.thong_tin_chung.kinh_do == undefined &&
          vui_choi_giai_tri.result.thong_tin_chung.vi_do == undefined
        ) {
          this.mData.dataForm.thong_tin_chung.kinh_do = 105.850176;
          this.mData.dataForm.thong_tin_chung.vi_do = 21.0287797;
          this.mData.dataDefault.showMap = true;
        }
        resForm.id = this.mData.dataForm.id;
      } else {
        this.$confirm(
          "Bạn chưa khai báo đầy đủ thông tin Đơn vị cung cấp, vui lòng khai báo trước khi truy cập tính năng này!",
          {
            confirmButtonText: LanguageService.lang.c_agree,
            showClose: false,
            showCancelButton: false,
            type: "warning",
          }
        )
          .then(() => {
            this.$router.push({
              name: "Admin-GiaiTriForm-create",
              params: { id: resForm.id },
            });
            if (vui_choi_giai_tri.result == undefined) {
              this.mData.dataForm.thong_tin_chung.kinh_do = 105.850176;
              this.mData.dataForm.thong_tin_chung.vi_do = 21.0287797;
              this.mData.dataDefault.showMap = true;
            }
          })
      }
    },

    fn_go() {
      this.$router.go(-1);
    },

    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.mediaId = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
      this.$refs["myForm"].validateField('mediaId');
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "giaiTri")
        .then(res => {
          this.mData.dataForm.mediaId = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
          this.$refs["myForm"].validateField('mediaId');
        })
        .catch(() => {
          this.$refs["myForm"].validateField('mediaId');
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_getDataFromMapboxComponent(value) {
      this.mData.mapDataObject = value;

    },
    fn_uploadExceedAnhDaiDien() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },
    handleBlur(prop) {
      this.$refs["myForm"].validateField(prop);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    }
  }
}
</script>
